import { Grid } from "@mui/material";
import React, { createContext, useRef, useState, } from "react";
import { Route, Routes } from "react-router-dom";
import { linear_v, linear_h, linear_item, } from "../libs/linear-layout/LinearLayout";
import AppMenu from "./AppMenu";
import AuthRequiredRoute from "./AuthRequiredRoute";
import { ADMIN_ROUTES, PUBLIC_ROUTES, RouteDefine, MEMBER_ROUTES } from "./Routes";


// import './MainForm.debug.css';

export const MainFormContext = createContext<null | {
  /** 開啟/關閉 左方 APP 主選單 */
  IsAppMenuOpen: boolean;
  set_IsAppMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;

  /** 如果有空間，是否固定顯示左側選單 */
  ShowAppMenuBreakPoint: string;
  set_ShowAppMenuBreakPoint: React.Dispatch<React.SetStateAction<string>>;
}>(null);

type Props = {};

const MainForm = (props: Props) => {
  const [IsAppMenuOpen, set_IsAppMenuOpen] = useState(false);

  const [ShowAppMenuBreakPoint, set_ShowAppMenuBreakPoint] = useState(""); // = useState("xl");

  const MainFormContentRef = useRef();

  return ( // render()
    <MainFormContext.Provider
      value={{
        IsAppMenuOpen,
        set_IsAppMenuOpen,
        ShowAppMenuBreakPoint,
        set_ShowAppMenuBreakPoint,
      }}
    >
      <Grid {...linear_v} className={"mainform "}>
        <Grid {...linear_item} className={"header"}>
          {render_Header()}
        </Grid>

        <Grid {...linear_item} {...linear_h} flex={"1"} className={"body"}>
          <Grid {...linear_item} className={"app-menu"}>
            {render_AppMenu()}
          </Grid>
          <Grid {...linear_item} className={"left-nav"}>
            {render_LeftNav()}
          </Grid>

          <Grid
            {...linear_item}
            flex={"1"}
            className={"content"}
            ref={MainFormContentRef}
          >
            {render_Content()} {/* $$$ */}
          </Grid>

          <Grid {...linear_item} className={"right-nav"}>
            {render_RightNav()}
          </Grid>
        </Grid>

        <Grid {...linear_item} className="footer">
          {render_Footer()}
        </Grid>
      </Grid>
    </MainFormContext.Provider>
  );

  function render_AppMenu(): React.ReactNode {
    return <AppMenu />;
  }

  function render_Content(): React.ReactNode {
    return (
      <>
        <Routes>
          {/* Admin Only Route */}
          <Route element={<AuthRequiredRoute adminOnly={true} />}>
            {renderRoutes(ADMIN_ROUTES)}
          </Route>

          {/* Login Required Route */}
          <Route element={<AuthRequiredRoute adminOnly={false} />}>
            {renderRoutes(MEMBER_ROUTES)}
          </Route>

          {/* Public Route */}
          {renderRoutes(PUBLIC_ROUTES)}

          {/* Others Route 應該導向至 404 Page */}
          <Route path="*" element={<p>404 Not Found</p>} />
        </Routes>
        {/* </BrowserRouter> */}
      </>
    );
  }

  function renderRoutes(routes: RouteDefine[]) {
    return routes.map((item: RouteDefine, index) => {
      if (item.page == null) {
        return undefined;
      }
      return <Route key={index} path={item.url} element={item.page} />;
    });
  }


  function render_Header(): React.ReactNode {
    return <></>;
  }

  function render_LeftNav(): React.ReactNode {
    return <></>;
  }

  function render_RightNav(): React.ReactNode {
    return <></>;
  }

  function render_Footer(): React.ReactNode {
    return <></>;
  }
};

export default MainForm;
